/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import { observable, action, flow } from 'mobx';
import ErrorsStore from './errorsStore';
import fetch from '../fetch';
import get from 'lodash/get';
import _ from '../translations';

const SEARCH_TYPES = {
    CONTENT: 'content',
    NEWS: 'news',
};

class SearchStore {
    @observable results = [];
    @observable searching = false;

    constructor() {
        this.baseUrl = '/api/search';
    }

    @action.bound
    clear() {
        this.results = [];
    }

    @action.bound
    search = flow(function*({ term = '', types, omitTypes } = {}) {
        this.searching = true;
        let response;
        try {
            response = yield fetch.post({
                url: '/api/search/search/search/',
                body: {
                    term,
                    types,
                    omitTypes,
                },
            });
            this.results = get(response, 'items', []);
        } catch (e) {
            ErrorsStore.addError(e, _('There was a problem in search'));
        }
        this.searching = false;
        return response;
    });
}

export { SEARCH_TYPES };
export default new SearchStore();
